export default function () {
    this.App_Type = ""; // 区分当前是实盘 还是模拟盘 dev ffc demo

    this.isDeskApp = false;

    this.appSourceUrl = 'http://45.138.81.119:8090/getApp.html'

    this.base_url = "";

    this.height = "";
    this.width = "";

    this.i18n = ""; // zh 中文版 en 英文国际版

    this.is_notice_jump = 0

    this.getQueryVariable = function (variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) {
                return pair[1];
            }
        }
        return false;
    };

    this.getQueryString = function (name) {
        var result = window.location.hash.match(
            new RegExp("[?&]" + name + "=([^&]+)", "i")
        );
        if (result == null || result.length < 1) {
            return "";
        }
        return result[1];
    };

    this.getBread = function (uid, that) {
        var _url = myutil.base_url + "/User/breadcrumb/" + uid;
        var msg = "";
        $.get({
            url: _url,
            async: false
        }).done(function (res) {
            res = res.replace('本账号', that.$t('本账号'))
            res = res.replace(/</g, '-')
            console.log(res)
            msg = res;
        });
        return msg;
    };

    this.asd = function (msg) {
        console.log(msg);
    };

    // 压缩图片后 宽度为800
    this.zip = function (base64, callback) {
        // 返回被压缩后的base64
        var bigImg = new Image();
        bigImg.src = base64;
        bigImg.onload = function () {
            var canvas = document.createElement("canvas");

            var mult = this.width / 800;

            var sWidth = parseInt(this.width / mult);
            var sHeight = parseInt(this.height / mult);

            canvas.width = sWidth;
            canvas.height = sHeight;

            canvas.getContext("2d").drawImage(bigImg, 0, 0, sWidth, sHeight);

            var sBase64 = canvas.toDataURL("image/jpeg");

            callback ? callback(sBase64) : null; //调用回调函数
        };
    };

    this.checkConnet = function (vm, detail) {
        if (detail.status != 200) {
            this.noticeLine("网络错误", "danger");
            vm.$router.push("/Login");
            return;
        }

        // var data = this.parseJson(detail.responseText)

        // if(data.hasOwnProperty('code') && data.code !=0){
        //   this.noticeLine('数据错误', 'danger')
        //   vm.$router.push("/Login");
        //   return
        // }
    };

    this.arraySum = function (arr) {
        var temp = 0;
        arr.forEach(function (v) {
            temp += Number(v);
        });
        return temp;
    };

    this.setBanner = function (vm, banner) {
        // 切换页面时 也切换 标题
        vm.$store.commit("set_banner", banner);
        document.getElementsByTagName("title")[0].innerText = banner;
    };

    this.pcFlag = true;

    this.pageCellHeight = 18;

    this.pageNum = parseInt(
        (window.innerHeight - 50 - 40 - 60 - 40 - 60 - 50) / 37
    );

    // 初始化每一个vm，赋值公共的method
    this.pageInit = function (vm) {
        vm.resetForm = function (formName) {
            vm.$refs[formName].resetFields();
        };

        vm.toggle = function () {
            vm.is_toggled = !vm.is_toggled;
        };

        $(function () {
            $("input").attr("autocomplete", "off");

            $(".datepicker").datepicker({
                autoclose: true,
                todayHighlight: true,
                language: "zh-CN",
                format: "yyyy-mm-dd"
            });
        });
    };

    this.viewInit = function (vm) {
        this.pageInit(vm);
    };

    this.changeStyle = function () {
        $("#myNavBar").addClass("hidden");
    };
    this.returnStyle = function () {
        $("#myNavBar").removeClass("hidden");
    };

    this.getFormValue = function (id) {
        var t = $(id).serializeArray();
        var d = {};

        $.each(t, function () {
            d[this.name] = this.value;
        });
        return d;
    };

    this.downloadCSV = function (data, name, flag) {
        function JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
            //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
            var arrData =
                typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;

            var CSV = "";
            //Set Report title in first row or line

            CSV += ReportTitle + "\r\n\n";

            //This condition will generate the Label/Header
            if (ShowLabel) {
                var row = "";
                //This loop will extract the label from 1st index of on array

                for (var index in arrData[0]) {
                    //Now convert each value to string and comma-seprated
                    row += index + ",";
                }

                row = row.slice(0, -1);

                //append Label row with line break
                CSV += row + "\r\n";
            }

            //1st loop is to extract each row
            for (var i = 0; i < arrData.length; i++) {
                var row = "";

                //2nd loop will extract each column and convert it in string comma-seprated
                for (var index in arrData[i]) {
                    row += '"' + arrData[i][index] + '",';
                }

                row.slice(0, row.length - 1);

                //add a line break after each row
                CSV += row + "\r\n";
            }

            if (CSV == "") {
                alert("Invalid data");
                return;
            }

            //Generate a file name
            var fileName = "";
            //this will remove the blank-spaces from the title and replace it with an underscore
            fileName += ReportTitle.replace(/ /g, "_");

            //Initialize file format you want csv or xls
            var uri = "data:text/csv;charset=utf-8,\uFEFF" + encodeURI(CSV);

            // Now the little tricky part.
            // you can use either>> window.open(uri);
            // but this will not work in some browsers
            // or you will not get the correct file extension

            //this trick will generate a temp <a /> tag
            var link = document.createElement("a");
            link.href = uri;

            //set the visibility hidden so it will not effect on your web-layout
            link.style = "visibility:hidden";
            link.download = fileName + ".csv";

            //this part will append the anchor tag and remove it after automatic click
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        JSONToCSVConvertor(data, name, flag);
    };

    this.changeStyle = function () {
        //依据是否是登录页展示不同风格
        $(".main-header").addClass("hidden");
        $(".main-sidebar").addClass("hidden");
        $(".content-wrapper").css("marginLeft", "0");
        $(".content").css("padding", "0");
        $(".content").css("minHeight", "800px");
    };

    this.returnStyle = function () {
        $(".main-header").removeClass("hidden");
        $(".main-sidebar").removeClass("hidden");
        $(".content-wrapper").css("marginLeft", "");
        $(".content").css("paddingLeft", "15px");
        $(".content").css("paddingTop", "15px");
    };

    this.quickNoticeLine = function (obj, that) {
        var data = "";
        if (typeof obj == "object") {
            data = obj;
        } else {
            data = JSON.parse(obj);
        }
        if (data.code == 0) {
            this.noticeLine(that.$t(data.msg), "info");
        } else {
            this.noticeLine(that.$t(data.msg), "danger");
        }
    };

    this.noticeLine = function (msg, type) {
        var html =
            "<div class='alert alert-" +
            type +
            "  alert-dismissable text-center' style = 'position:fixed;top:50px;z-index:2000;width: 100%;margin:auto'><button type='button' class='close' data-dismiss='alert' aria-hidden='true'>&times;</button>" +
            msg +
            "</div >";
        $("#app")
            .first()
            .append(html);

        setTimeout(function () {
            $(".alert")
                .slideToggle("slow")
                .remove();
        }, 2500);
    };

    this.test = function () {
        console.log("myutil ok");
    };

    // '2018-07-06 15:16:30'
    this.parseTime = function (timesatmp) {
        var Time = new Date(timesatmp);
        var year = Time.getFullYear();
        var month = (String("0") + (Number(Time.getMonth()) + 1)).substr(-2);
        var day = (String("0") + (Number(Time.getDate()) + 0)).substr(-2);

        var hour = (String("0") + (Number(Time.getHours()) + 0)).substr(-2);
        var min = (String("0") + (Number(Time.getMinutes()) + 0)).substr(-2);
        var sec = (String("0") + (Number(Time.getMinutes()) + 0)).substr(-2);

        var res =
            year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
        return res;
    };

    this.checkLogin = function (vm, to, from) {
        console.log("checkLogin ok");
        var _url = vm.myutil.base_url + "/user/islogin";
        $.get(_url).done(function (res) {
            var data = JSON.parse(res);
            if (data.code == 0) {
                var whiteList = ["Reg", "ResetPwd"];
                if ($.inArray(to.name, whiteList) >= 0) {
                    return;
                }
                if (to.name == "Login") {
                    vm.$router.push("/user/home");
                }
            } else {
                vm.$store.commit("set_isLogin", "");
                vm.$router.push("/");
            }
        });
    };

    this.compare = function (property) {
        return function (obj1, obj2) {
            var value1 = obj1[property];
            var value2 = obj2[property];
            return value1 - value2; // 升序
        };
    };

    this.simpleNotyf = function (obj) {
        var data = "";
        if (typeof obj == "object") {
            data = obj;
        } else {
            data = JSON.parse(obj);
        }
        if (data.code == 0) {
            notyf.confirm(data.msg);
        } else {
            notyf.alert(data.msg);
        }
    };

    this.initDatepicker = function () {
        $(".datepicker").datepicker({
            autoclose: true,
            todayHighlight: true,
            language: "zh-CN",
            format: "yyyymmdd"
        });
    };

    // 字符串json化
    // obj : str 或者 obj
    this.parseJson = function (obj) {
        var data = "";
        if (typeof obj == "object") {
            data = obj;
        } else {
            data = JSON.parse(obj);
        }
        return data;
    };

    this.pager = function (vm, arr) {
        $("#pagination").jqPaginator({
            totalPages: Math.ceil(arr.length / 10),
            visiblePages: 3,
            currentPage: 1,
            onPageChange: function (num, type) {
                vm.data = arr.slice((num - 1) * 10, (num - 1) * 10 + 10);
            }
        });
        $("#pagination").jqPaginator("option", {
            first: "<li class='first'><a href='javascript:void(0);'>首页</a></li>",
            prev: "<li class='prev'><a href='javascript:void(0);'>《</a></li>",
            next: "<li class='next'><a href='javascript:void(0);'>》</a></li>",
            last: "<li class='last'><a href='javascript:void(0);'>末页</a></li>",
            page: "<li class='page'><a href='javascript:void(0);'>{{page}}</a></li>"
        });
    };
}


// WEBPACK FOOTER //
// ./src/assets/js/class_util.js